import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import { Language } from '../types';

interface ScrollToTopButtonProps {
  currentLang?: Language;
}

export const ScrollToTopButton: React.FC<ScrollToTopButtonProps> = ({ currentLang = 'fr' }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-6 left-6 rtl:left-auto rtl:right-6 z-40 bg-slate-900 text-white dark:bg-white dark:text-slate-900 p-3 rounded-sm shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 flex items-center justify-center"
      aria-label={currentLang === 'ar' ? 'الرجوع إلى أعلى الصفحة' : currentLang === 'en' ? 'Back to top' : 'Retour en haut'}
      title={currentLang === 'ar' ? 'أعلى الصفحة' : currentLang === 'en' ? 'Scroll to top' : 'Haut de page'}
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
};
